"use client";

import { ImageCropModal } from "@/components/revive-create/ImageCropModal";
import {
  BANNER_ASPECT,
  BANNER_OUTPUT_HEIGHT,
  BANNER_OUTPUT_WIDTH,
} from "@/lib/revive-create/banner-crop-export";

export function BannerCropModal({ open, imageSrc, onClose, onApply }) {
  return (
    <ImageCropModal
      open={open}
      imageSrc={imageSrc}
      onClose={onClose}
      onApply={onApply}
      aspect={BANNER_ASPECT}
      outputWidth={BANNER_OUTPUT_WIDTH}
      outputHeight={BANNER_OUTPUT_HEIGHT}
      title="Crop to banner"
      description={`Frame matches ${BANNER_OUTPUT_WIDTH}×${BANNER_OUTPUT_HEIGHT}px (3:1). Drag to reposition, use zoom to fit.`}
    />
  );
}
